module.exports = __webpack_public_path__ + "img/South-Indian-Bank.59859afc.jpg";